import httpClient from "Api/httpClient";

const END_POINT = "/devices";
const MOBILE_PROVIDERS_END_POINT = "/mobile_providers";

const getDevices = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body, useCache: true }); // useCahe: true, retryTimes: 3, throttle: true
};

const getDevice = (device_id) => {
    if (!device_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + device_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printDevice = (device_id) => {
    if (!device_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?device_id=" + device_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createDevices = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};
const createDeviceBulk = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const POST_END_POINT = "/devices/bulk";
    return httpClient.post(POST_END_POINT, body);
};

const updateDevices = (payload, device_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + device_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteDevices = (device_id) => {
    const DELETE_END_POINT = END_POINT + "/" + device_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const getDeviceTypes = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const END_POINT = "/device_types";
    return httpClient.get(END_POINT, { params: body });
};

const getSignalStrengthGraph = (payload) => {
    const GET_END_POINT = END_POINT + "/" + payload.id + "/signal_strength_graph/";
    return httpClient.get(GET_END_POINT);
};

const getPortHistoryGraph = (device_id, port_id) => {
    const GET_END_POINT = END_POINT + "/" + device_id + "/port_history_graph/" + port_id;
    return httpClient.get(GET_END_POINT, { retryTimes: 3 }); // useCahe: true, retryTimes: 3, throttle: true
};

const attachDeviceTag = (device_id, tags) => {
    const POST_END_POINT = END_POINT + "/" + device_id + "/attach_tags/" + tags;
    return httpClient.post(POST_END_POINT);
};

const deleteDeviceTag = (device_id, tag_id) => {
    const DELETE_END_POINT = END_POINT + "/" + device_id + "/tags/" + tag_id;
    return httpClient.delete(DELETE_END_POINT);
};

const attachNewDeviceTag = (payload, device_id) => {
    let body = "";
    if (payload.body) body = payload.body;
    const POST_END_POINT = END_POINT + "/" + device_id + "/tags";
    return httpClient.post(POST_END_POINT, body.tag);
};

const getBatteryGraph = (payload) => {
    const GET_END_POINT = END_POINT + "/" + payload.id + "/battery_graph/";
    return httpClient.get(GET_END_POINT);
};

const reprovisionDevice = (device_id) => {
    const PATCH_END_POINT = END_POINT + "/" + device_id + "/reprovision";
    return httpClient.patch(PATCH_END_POINT);
};

const updateDevicePort = (payload, device_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + device_id + "/ports/" + payload.body.device_ports_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const createDevicePort = (payload, device_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const POST_END_POINT = END_POINT + "/" + device_id + "/ports";
    return httpClient.post(POST_END_POINT, body);
};

const createDevicePortTank = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const POST_END_POINT = "/tank_specs";
    return httpClient.post(POST_END_POINT, body);
};

const updateDevicePortTank = (payload, tank_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = "/tank_specs/" + tank_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteDevicePortTank = (tank_id) => {
    const DELETE_END_POINT = "/tank_specs/" + tank_id;
    return httpClient.delete(DELETE_END_POINT);
};

const deleteDevicePort = (port_id, device_id) => {
    const DELETE_END_POINT = END_POINT + "/" + device_id + "/ports/" + port_id;
    return httpClient.delete(DELETE_END_POINT);
};

const getTemperatureGraph = (payload) => {
    const GET_END_POINT = END_POINT + "/" + payload.id + "/temperature_graph/";
    return httpClient.get(GET_END_POINT);
};

const createProductMove = (payload, device_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const POST_END_POINT = END_POINT + "/" + device_id + "/move";
    return httpClient.patch(POST_END_POINT, body);
};

const getLT14DeviceLogs = (device_id) => {
    const GET_END_POINT = END_POINT + "/" + device_id + "/lt14_log/";
    return httpClient.get(GET_END_POINT);
};

const getDeviceUsers = (device_id) => {
    const GET_END_POINT = END_POINT + "/" + device_id + "/users/";
    return httpClient.get(GET_END_POINT);
};

const getDevicesForMap = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const GET_END_POINT = END_POINT + "/gps_coords";
    return httpClient.get(GET_END_POINT, { params: body });
};

const getMobileProviders = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const GET_END_POINT = MOBILE_PROVIDERS_END_POINT;
    return httpClient.get(GET_END_POINT, { params: body });
};

const getTankManufacturerSpecs = (id, payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const GET_END_POINT = "/tank_manufacturers/" + id + "/specifications";
    return httpClient.get(GET_END_POINT, { params: body });
};

export {
    getDevices,
    getDevice,
    printDevice,
    createDevices,
    updateDevices,
    deleteDevices,
    getDeviceTypes,
    getSignalStrengthGraph,
    getPortHistoryGraph,
    attachDeviceTag,
    deleteDeviceTag,
    attachNewDeviceTag,
    createDeviceBulk,
    getBatteryGraph,
    reprovisionDevice,
    updateDevicePort,
    createDevicePort,
    createDevicePortTank,
    updateDevicePortTank,
    deleteDevicePortTank,
    deleteDevicePort,
    getTemperatureGraph,
    createProductMove,
    getLT14DeviceLogs,
    getDeviceUsers,
    getDevicesForMap,
    getMobileProviders,
    getTankManufacturerSpecs,
};
